import { render, staticRenderFns } from "./SliderType.vue?vue&type=template&id=2ee3c0ee&scoped=true"
import script from "./SliderType.vue?vue&type=script&lang=js"
export * from "./SliderType.vue?vue&type=script&lang=js"
import style0 from "./SliderType.vue?vue&type=style&index=0&id=2ee3c0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3c0ee",
  null
  
)

export default component.exports